module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid4_800X800.675b6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid4_800X800.jpg
// module id = m6U9
// module chunks = 0